<template> 
  <div class="p-fluid p-formgrid p-grid">

    <div class="p-field p-col-12 p-md-6" v-if="!esconderPreconfigurado">
      <label for="estado">Pré-configurado</label>							
      <Dropdown v-model.number="idPreCofigSelecioinado" @change="selecionarPreConfigurado" :options="preConfigurados" optionLabel="periodo" optionValue="id"/>   
    </div>  
    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Horários <span class="campo-obrigatorio">*</span></h6>        
      <hr/>
      <div class="p-d-flex p-mb-3">
          <div class="box-horario cabecalho-horario p-text-bold">Dia</div>
          <div class="box-horario cabecalho-horario p-text-bold">1ª Entrada</div>
          <div class="box-horario cabecalho-horario p-text-bold">1ª Saída</div>
          <div class="box-horario cabecalho-horario p-text-bold">2ª Entrada</div>
          <div class="box-horario cabecalho-horario p-text-bold">2ª Saída</div>
          <template v-if="preConfiSelecionado.intervalos == 2">
          <div class="box-horario cabecalho-horario p-text-bold" >3ª Entrada</div>
          <div class="box-horario cabecalho-horario p-text-bold" >3ª Saída</div>
          </template>
          <div class="box-horario cabecalho-horario p-text-bold">Horário flexível</div>
          <div class="box-horario cabecalho-horario p-text-bold copiar-horario" @click="copiarHorariosAteSex">
            <i class="pi pi-arrow-circle-down copiar-horario" title="Copiar horários de Seg até Sex"></i>
          </div>
      </div>
      <div class="p-d-flex linha-horario" v-for="horario in preConfiSelecionado.horarios" :key="horario.dia" :class="horario.dia == 1 ? 'ultima-linha' : ''">
          <div class="box-horario p-text-bold p-text-center">{{ horario.diaSem }}</div>
          <div class="box-horario p-text-bold"><InputText v-model="horario.entrada1" maxlength="5" placeholder=":" class="p-text-center" @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(horario,'entrada1')"/></div>
          <div class="box-horario p-text-bold"><InputText v-model="horario.saida1" maxlength="5" placeholder=":" class="p-text-center" @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(horario,'saida1')"/></div>
          <div class="box-horario p-text-bold"><InputText v-model="horario.entrada2" maxlength="5" placeholder=":" class="p-text-center" @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(horario,'entrada2')"/></div>
          <div class="box-horario p-text-bold"><InputText v-model="horario.saida2" maxlength="5" placeholder=":" class="p-text-center" @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(horario,'saida2')"/></div>
          <template v-if="preConfiSelecionado.intervalos == 2">
          <div class="box-horario p-text-bold" ><InputText v-model="horario.entrada3" maxlength="5" placeholder=":" class="p-text-center" @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(horario,'entrada3')"/></div>
          <div class="box-horario p-text-bold" ><InputText v-model="horario.saida3" maxlength="5" placeholder=":" class="p-text-center" @keyup="validarEntraHora" @focusout="limparEntradaHoraInvalida(horario,'saida3')"/></div>
          </template>
          <div class="box-horario p-text-bold p-text-center"><Checkbox :binary="true" v-model="horario.horarioFlexivel"/></div>
      </div>      
    </div>      

    <div class="p-field p-col-12 p-md-12 p-mt-2">
      <h6 class="p-text-bold">Refeição/Intervalo</h6>
      <hr/>
      <div class="p-formgroup-inline">
        <div class="p-field-radiobutton">
          <RadioButton id="parametroRefeicao1" name="parametroRefeicao" v-model.number="parametroRefeicao" :value="2" @click="validarOpcaoIntervalo(2)"/>
          <label>Marcação inexistente</label>
        </div>
        <div class="p-field-radiobutton">
          <RadioButton id="parametroRefeicao2" name="parametroRefeicao" v-model.number="parametroRefeicao" :value="3" @click="validarOpcaoIntervalo(3)"/>
          <label>Marcação pré-assinalada</label>
        </div>
        <div class="p-field-radiobutton">
          <RadioButton id="parametroRefeicao3" name="parametroRefeicao" v-model.number="parametroRefeicao" :value="4" @click="validarOpcaoIntervalo(4)"/>
          <label>Marcação flexível</label>
        </div>
      </div>
    </div>

    <div class="p-field p-col-12 p-md-12" v-if="exibirMensagemOpcaoIntervalo">
        <Message severity="warn">{{ mensagemOpcaoIntervalo }}</Message>
    </div>

    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Lanche</h6>
      <div class="p-field-checkbox">
        <Checkbox v-model="descontarSegundoIntervalo" :binary="true"/>
        <label>Descontar o segundo intervalo</label>
      </div>
    </div>

    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Fechamento</h6>        
      <hr/>   
      <div class="p-formgroup-inline">
        <div class="p-field p-col-12 p-md-12">
            <Message severity="warn" :sticky="true" :closable="false">
                Atenção! <br/>
                Selecione com cuidado o Horário Noturno.<br/>
                Caso o horário de saída seja próximo da meia-noite ou ultrapasse esse horário, selecione esta opção.<br/>
                Além disso, defina a quantidade de horas para validação após o término do expediente regular do(s) funcionário(s).
            </Message>
        </div>
        <div class="p-field-checkbox">
          <Checkbox v-model="validarFechamento" @click="desbloquearHorasValidar" :binary="true"/>
          <label>Horário Noturno</label>
        </div>
        <div class="p-field">                
          <InputText v-model.number="horasValidarFechamento" type="number" placeholder="Horas para o fechamento" :disabled="disabledHorasValidarFechamento"/>
        </div>            
      </div>
    </div>
    
  </div>	 
</template>

<script>
import QuadroHorario from '@/model/QuadroHorario';
import { clonar, formatarEtradaHora} from '@/global';

export default {    
  data() {
    return {    
      conponenteCarregado: false,
      quadroHorario: new QuadroHorario(),
      disabledHorasValidarFechamento: true,      
      horasValidarFechamento: null,
      validarFechamento: false,
      idPreCofigSelecioinado: 0,
      preConfiSelecionado: null,
      preConfigurados: [],
      esconderPreconfigurado: false,
      parametroRefeicao: 4,
      mensagemOpcaoIntervalo: '',
      exibirMensagemOpcaoIntervalo: false,
      descontarSegundoIntervalo: false
    }
  },
  methods: {
    selecionarPreConfigurado(event) {  
      this.preConfiSelecionado = clonar(this.preConfigurados[event.value]);    
    },
    desbloquearHorasValidar() {
      if(this.horasValidarFechamento !== null) {
        this.horasValidarFechamento = null;
        this.validarFechamento = false;
      } else {
        this.horasValidarFechamento = null;
        this.disabledHorasValidarFechamento = this.validarFechamento;
      }      
    },
    copiarHorariosAteSex() {     
      let horario = this.preConfiSelecionado.horarios[0];
      this.preConfiSelecionado.horarios.forEach((diaHora, index) => {
        if(index < 5) {
          diaHora.entrada1 = horario.entrada1;
          diaHora.saida1 = horario.saida1;
          diaHora.entrada2 = horario.entrada2;
          diaHora.saida2 = horario.saida2;
          diaHora.entrada3 = horario.entrada3;
          diaHora.saida3 = horario.saida3;
          diaHora.horarioFlexivel = horario.horarioFlexivel;
        }
      });
    },
    limparEntradaHoraInvalida(data, campo) {
      if(data[campo] == null) {
        return;
      }
      let regex = /[0-2][0-9]:[0-5][0-9]/g;
      if(!data[campo].match(regex)) {
        data[campo] = '';
      }
    },
    validarEntraHora(event) {
      formatarEtradaHora(event);
    },    
    setConfiguracao(configuracaoEscalaHorario) {
      let quadroHorario = configuracaoEscalaHorario.quadroHorario;
      let diasDaSemana = configuracaoEscalaHorario.diasDaSemana;
      let intervalos = configuracaoEscalaHorario.intervalos;
      this.parametroRefeicao = configuracaoEscalaHorario.parametroRefeicao;
      this.descontarSegundoIntervalo = configuracaoEscalaHorario.descontarSegundoIntervalo;
      this.esconderPreconfigurado = true;
      this.quadroHorario = quadroHorario;
      this.validarFechamento = quadroHorario.validarFechamento;
      this.horasValidarFechamento = quadroHorario.horasFechamento;
      let diasSem = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
      let domingo = null;
      this.preConfiSelecionado.horarios = [];
      diasDaSemana.forEach(diaS => {
        if(diaS.dia == 1) {
          domingo = diaS;
          domingo['diaSem'] = diasSem[(diaS.dia - 1)];
        } else {
          diaS['diaSem'] = diasSem[(diaS.dia - 1)];
          this.preConfiSelecionado.horarios.push(diaS);
        }
      });
      this.preConfiSelecionado.horarios.push(domingo);      
      this.preConfiSelecionado.intervalos = intervalos;
    },
    getConfiguracao() {      
      if(this.quadroHorario.id == null) {
        this.quadroHorario = new QuadroHorario();
      } 
      if(this.validarFechamento) {
        if(this.horasValidarFechamento == null || this.horasValidarFechamento == 0) {
          throw 'Quadro de horários: Validar o fechamento selecionado. Informe o tempo para validar o fechamento';
        } else {
          this.quadroHorario.validarFechamento = true;
           this.quadroHorario.horasFechamento = this.horasValidarFechamento;
        }        
      }   
      this.quadroHorario.tipoEscala = 'EQH';      
      let definicaoHoraio = {
        quadroHorario: clonar(this.quadroHorario),
        diasDaSemana: clonar(this.preConfiSelecionado.horarios),
        diasDaSemanaExcluir: [],
        parametroRefeicao: this.parametroRefeicao, // Esse atriburo está no obj PoliticaContratual.
        descontarSegundoIntervalo: this.descontarSegundoIntervalo // Esse atriburo está no obj PoliticaContratual.
      }
      return definicaoHoraio;
    },
    criarPreConfiguradas() {        
      this.preConfigurados = [];            
      let entradasSaidas = [];
      entradasSaidas.push({limite:6, batidas:[], periodo: 'Personalizado - Um intervalo', intervalos: 1, personalizado: true});
      entradasSaidas.push({limite:6, batidas:[], periodo: 'Personalizado - Dois intervalos', intervalos: 2, personalizado: true});
      entradasSaidas.push({limite:6, batidas:['09:00','12:00','13:00','18:00'], periodo: '40h semanais 09:00 - 18:00 (Seg a Sex)', 
        intervalos: 1, personalizado: false});
      entradasSaidas.push({limite:6, batidas:['08:00','12:00','13:00','17:00'], periodo: '40h semanais 08:00 - 17:00 (Seg a Sex)', 
        intervalos: 1, personalizado: false});
      entradasSaidas.push({limite:7, batidas:['08:00','12:00','13:00','16:00'], batidasSabado: ['08:00','11:00','12:00','14:00'], 
        periodo: '40h semanais 08:00 - 16:00 (Seg a Sáb)', intervalos: 1, personalizado: false});
      entradasSaidas.push({limite:7, batidas:['08:00','12:00','13:00','17:00'], batidasSabado: ['08:00','11:00','12:00','13:00'], 
        periodo: '44h semanais 08:00 - 17:00 (Seg a Sáb)', intervalos: 1, personalizado: false});
     let index = 0;
     let diasSem = ['','','Seg','Ter','Qua','Qui','Sex','Sáb'];
     entradasSaidas.forEach(entSai => {
          let horarios = [];
          for(let i = 2; i <= 7; i++) {
              let novoHorario = {id:null,dia:i,referenciaCiclo:null,horarioFlexivel:false,entrada1:null,saida1:null,entrada2:null,saida2:null, diaSem: diasSem[i]};              
              if(entSai.personalizado) {                   
                  horarios.push(novoHorario)
              } else {
                  if(i <= entSai.limite) {
                      let batidas = i == 7 ? entSai.batidasSabado : entSai.batidas;             
                      novoHorario.entrada1 = batidas[0];
                      novoHorario.saida1 = batidas[1];
                      novoHorario.entrada2 = batidas[2];
                      novoHorario.saida2 = batidas[3];                        
                  } 
                  horarios.push(novoHorario);                 
              }              
          }    
          // Domingo
          horarios.push({id:null,dia:1,referenciaCiclo:null,horarioFlexivel:false,entrada1:null,saida1:null,entrada2:null,saida2:null, diaSem:'Dom'});        
          let preConfig = {id: index, periodo: entSai.periodo, horarios: horarios, intervalos: entSai.intervalos, personalizado: entSai.personalizado};
          index++;
          this.preConfigurados.push(preConfig);          
      }); 
    },
    validarOpcaoIntervalo(opcao) {
      if(opcao == 3) {
        this.exibirMensagemOpcaoIntervalo = true;
        this.mensagemOpcaoIntervalo = 'Marcação Pré-assinalada para a Refeição: configure os horários nos campos 1ª Saída e 2ª Entrada. Não selecionar horário flexivel!';
        setTimeout(() => { this.exibirMensagemOpcaoIntervalo = false }, 60000);
      } else if(opcao == 2) {
        this.exibirMensagemOpcaoIntervalo = true;
        this.mensagemOpcaoIntervalo = 'Marcação Inexistente para a Refeição: configure os horários somente nos campos 1ª Entrada e 1ª Saída';
        setTimeout(() => { this.exibirMensagemOpcaoIntervalo = false }, 60000);      
      } else {
        this.exibirMensagemOpcaoIntervalo = false;
        this.mensagemOpcaoIntervalo = '';
      }
    },
    carregado() {
      return this.conponenteCarregado;
    }
  },
  created() {      
    this.criarPreConfiguradas();
    this.preConfiSelecionado = clonar(this.preConfigurados[0]);  
  },
  mounted() {           
    this.conponenteCarregado = true;
  }
}
</script>  

<style>

  .cabecalho-horario {
    color: #6C757D;
    text-align: center;
  }

  .box-horario {
    width: 100px;    
    margin-right: 5px;
  }

  .linha-horario {
    border-top: 1px solid #E3E3E3;    
    padding: 10px 0px 10px 0px;
  }

  .ultima-linha {
    border-bottom: 1px solid #E3E3E3;
  }

  .copiar-horario {
    color: #1B8AED;
  }

  .copiar-horario :hover {
    cursor:pointer;
  }
</style>